import { Injectable } from '@angular/core';
import { switchMap, tap } from 'rxjs/operators';

import { Folder } from '@app/models';
import { FolderService } from '@app/services';
import { AlertModalService } from '@app/shared';
import { CreateFolderModalService } from './create-folder-modal/create-folder-modal.service';
import { UpdateFolderModalService } from './update-folder-modal/update-folder-modal.service';
import { FoldersModalService } from './folders-modal/folders-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ShareFolderModalService } from './share-folder-modal/share-folder-modal.service';
import { AddFolderSharingModalService } from './add-folder-sharing-modal/add-folder-sharing-modal.service';

@Injectable({ providedIn: 'root' })
export class FoldersListingService {
  constructor(
    private folderService: FolderService,
    private alertModalService: AlertModalService,
    private createFolderModalService: CreateFolderModalService,
    private updateFolderModalService: UpdateFolderModalService,
    private shareFolderModalService: ShareFolderModalService,
    private addFolderSharingModalService: AddFolderSharingModalService,
    private foldersModalService: FoldersModalService,
    private translateService: TranslateService
  ) {}

  openFoldersModal(allFolders: Folder[], folder: Folder, isNewDocument?: boolean, currentFolderId?: string) {
    return this.foldersModalService.open({ targetType: 'folder', itemsToMove: folder, isNewDocument, currentFolderId }).pipe(
      tap(() =>
        allFolders.splice(
          allFolders.findIndex(item => item.id === folder.id),
          1
        )
      )
    );
  }

  delete(allFolders: Folder[], targetFolder: Folder) {
    return this.alertModalService
      .warning({
        text: this.translateService.instant('alerts.deleteFolders'),
        confirmButtonText: this.translateService.instant('button.exclude'),
        dismissAsError: true
      })
      .pipe(
        switchMap(() =>
          this.folderService.delete({ id: targetFolder.id }).pipe(
            tap(() =>
              allFolders.splice(
                allFolders.findIndex(item => item.id === targetFolder.id),
                1
              )
            )
          )
        )
      );
  }

  openCreateFolderModal(options: { parentId?: string } = {}) {
    return this.createFolderModalService.open({ parentId: options.parentId });
  }

  openUpdateFolderModal(folder: Folder) {
    return this.updateFolderModalService.open({ folder });
  }

  openShareFolderModal(options: { folder: Folder; organizationId?: number }) {
    return this.shareFolderModalService.open(options);
  }

  openAddFolderSharingModal(options: { folder: Folder; isGroup?: boolean; organizationId?: number }) {
    return this.addFolderSharingModalService.open(options);
  }
}
